var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"public-content"},[_c('div',{staticClass:"login-container"},[_vm._m(0),_c('div',{staticClass:"right-item"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-item"},[_c('div',{staticClass:"img img-cover"},[_c('img',{attrs:{"src":require("../../assets/pc-images/login-img.png")}})])])
}]

export { render, staticRenderFns }